import CountryPageRenderer from '../components/CountryPageRenderer';
import mauritiusData from '../data/country-pages/mauritius';

export default function MauritiusCountryPage() {
  return <CountryPageRenderer data={mauritiusData} />;
}
